import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [msg, setMsg] = useState('');
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    const users = JSON.parse(localStorage.getItem('users')) || [];
    const user = users.find((u) => u.email === email && u.password === password);

    if (user) {
      setMsg('Login successful!');
      // Save user info (including name) to localStorage
      localStorage.setItem('loggedInUser', JSON.stringify(user));
      navigate('/');
    } else {
      setMsg('Invalid email or password.');
    }
  };

  return (
    <div className="container mt-5">
      <h2>Login</h2>
      {msg && <div className="alert alert-info">{msg}</div>}
      <form onSubmit={handleLogin}>
        <input className="form-control mb-3" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" required />
        <input className="form-control mb-3" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" required />
        <button className="btn btn-primary w-100">Login</button>
      </form>
      <p className="mt-3">
        Don’t have an account? <Link to="/signup">Create one</Link>
      </p>
      <p>
        Forgot password? <Link to="/forgot-password">Click here</Link>
      </p>
    </div>
  );
};

export default Login;
